import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";
import { logUI } from '../../api/andyliticsApi';
import moment from 'moment-timezone';
import MultiLineSelect from "../common/input/multiLineSelect";
import { Link } from 'react-router-dom';

/**
 * Container component for the Support Request page.
 * 
 */

class SupportNewRequest extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader: false,
            shouldLoadData: true,
            searchText: "",
            requestTypeOptions: [{ value: "Question", label: "Question" }, { value: "Comment", label: "Comment" }],
            requestType: null,
            showSubmitLoader: false,
            requestIssueResponse: null,
            showRequestError: false,
            requestError: "Sorry, we are unable to submit your request at this time. Please try again later.",
            fileUploadOptions: null,
            file: null
        };
        this.requestError = "Sorry, we are unable to submit your request at this time. Please try again later.";
        this.state.requestType = this.state.requestTypeOptions[0].value;
        this.goToSupportPage = this.goToSupportPage.bind(this);
        this.submitRequest = this.submitRequest.bind(this);
        this.getBase64 = this.getBase64.bind(this);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.Support.ComponentDidMount", new Date(), Tools.getURLPath());
        this.props.getSupportNotice();
        this.componentDidUpdate(this.props);
    }

    componentDidUpdate(prevProps) {
        const { hpIdentity, isFetching, swhp } = this.props;

        if (this.state.showSubmitLoader && this.props.crmCreateTicketResponse !== prevProps.crmCreateTicketResponse) {
            this.setState({ showSubmitLoader: false, requestIssueResponse: this.props.crmCreateTicketResponse });
        } else if (this.state.showSubmitLoader && !isFetching && this.props.error !== prevProps.error) {
            this.setState({ showSubmitLoader: false, showRequestError: true });
        }

        if ((swhp || hpIdentity) && this.state.shouldLoadData && !isFetching) {
            var hpSourceSystem = swhp ? "Amisys" : "Health Rules";
            this.setState({
                shouldLoadData: false,
                isSWHP: swhp || hpIdentity.loginOrganization === "SWHPC" ? true : false,
                isFirstCare: !swhp && hpIdentity.loginOrganization === "FCHP" ? true : false,
                hpSourceSystem: hpSourceSystem
            });
        }
    }

    goToSupportPage() {
        this.props.history.goBack();
    }

    getFileByteSize(base64String) {
        var base64only = base64String.includes(";") ? base64String.split(";")[1].replace("base64,", "") : base64String;
        var lastTwoChars = base64only.length > 1 ? base64only.substring(base64only.length - 2) : "x=";
        var byteLength = lastTwoChars === "==" ? (base64only.length * (3 / 4)) - 2 : (base64only.length * (3 / 4)) - 1;
        return byteLength;
    }

    submitRequest() {
        this.setState({ showSubmitLoader: true, showRequestError: false, requestError: this.requestError });
        let description = document.getElementById("support-request-message").value;
        if (description.trim().length === 0) {
            this.setState({ showSubmitLoader: false, showRequestError: true, requestError: "Please enter a more detailed message" });
            window.scrollTo(0, document.body.scrollHeight);
            return;
        }

        if (this.state.file) {
            this.getBase64(this.state.file).then(base64 => {
                if ((this.getFileByteSize(base64) / 1000000) > 5) {
                    console.log("too big: ", this.getFileByteSize(base64));
                    this.setState({ requestError: "Please select a file smaller than 5 MB.", showSubmitLoader: false, showRequestError: true });
                    window.scrollTo(0, document.body.scrollHeight);
                    return;
                }

                if (base64.includes(";")) {
                    var mimetype = base64.split(";")[0].replace("data:", "");
                    var base64only = base64.split(";")[1].replace("base64,", "");
                    this.props.createCrmTicket(this.state.requestType, description, this.state.file.name, base64only, this.state.requestType, mimetype, this.state.hpSourceSystem);
                }
            });
        }
        else {
            this.props.createCrmTicket(this.state.requestType, description, "", "", this.state.requestType, "", this.state.hpSourceSystem);
        }
    }

    getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    validateFileFormat() {

        return true;
    }

    handleFileInput(event) {
        if (event && event.target && event.target.files && event.target.files.length === 1) {
            this.setState({ file: event.target.files[0] });
            return;
        }
    }

    render() {
        const { swhp, isSWHP, serverData } = this.props;
        return (
            <div className="container-fluid body-content hp">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div className="support-request-wrapper">
                            {
                                this.state.showLoader
                                    ?
                                        <div id="support-request-spinner" className="spinner">
                                            <div className="bounce1" />
                                            <div className="bounce2" />
                                            <div className="bounce3" />
                                        </div>
                                    :
                                !this.state.requestIssueResponse
                                ?
                                    <div className="support-request-container">
                                        <div className="hp-title">What can we help you with today?</div>
                                            <div className="support-request-content">
                                                <div className="support-request-description">Welcome to the Support Center.  The hours of operation are Monday - Friday from 8:00 AM to 5:00 PM. If you need assistance outside these hours, please call the phone number on the back of your Member Identification Card.</div>
                                                {this.props.supportNoteMessage && < div className="support-notice">{this.props.supportNoteMessage}</div>}
                                                {this.state.showSubmitLoader ?
                                                    <div id="support-request-form-spinner" className="spinner">
                                                        <div className="bounce1" />
                                                        <div className="bounce2" />
                                                        <div className="bounce3" />
                                                    </div>
                                                    :
                                                    <div className="support-request-form">
                                                        <div className="support-request-dropdown">
                                                            <MultiLineSelect name="type" placeholder="Select a Message Type"
                                                                value={this.state.requestType} options={this.state.requestTypeOptions} required
                                                                onChange={(e, value) => this.setState({ requestType: value })}
                                                                id="support-request-type"
                                                            />
                                                        </div>
                                                        <div className="support-request-message-container">
                                                            <textarea id="support-request-message" className="large-message-input support-request-message-input" placeholder="Enter a message"/>
                                                        </div>
                                                        <div className="support-request-button-container">
                                                            <input type="button" onClick={() => this.goToSupportPage()} className="btn support-request-cancel-button" value="cancel" />
                                                            <div className="support-request-submit-container">
                                                                <div className={`support-file-upload-name ${this.state.file ? "" : "hidden"}`}>{this.state.file ? this.state.file.name : ""}</div>
                                                                <div className="support-file-upload-container">
                                                                    <input type="file" id="support-request-file-upload" onChange={(e) => this.handleFileInput(e)} style={{ "display": "none" }} />
                                                                    <div className="support-attach-file" onClick={() => document.getElementById("support-request-file-upload").click()}>
                                                                        <div className="icon-archive" />
                                                                    </div>
                                                                </div>
                                                                <input type="button" onClick={() => this.submitRequest()} className="btn support-request-submit-button" value="submit" disabled={this.props.isReadOnly} />
                                                            </div>
                                                        </div>
                                                        <div className="bold-text entered-style submit-error-container">
                                                            {this.state.showRequestError ? this.state.requestError : ""}
                                                        </div>
                                                    </div>
                                                }
                                    </div>
                                </div>
                                :
                                <div id="support-submitted-message" className="support-request-container">
                                    <div className="support-request-banner">
                                        <span className="icon-list-check support-request-checkmark"></span>Thanks, your message has been sent!
                                    </div>
                                    <div className="support-request-submit-complete-container">
                                                <div className="support-request-description">Our hours of operation are Monday - Friday from 8:00 AM to 5:00 PM.  We will respond to your message on the next business day. If you need assistance outside these hours, please call 800.321.7947.</div>
                                        <div className="support-request-button-container">
                                            <input type="button" id="support-request-see-all-tickets" onClick={() => { this.goToSupportPage(); }} className="btn support-request-submit-button" value="See All Support Requests" />
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

const mapStateToProps = (state, ownProps) => {
    return {
        serviceRequestResponse: state.healthPlanServices.serviceRequestResponse,
        attachmentOptions: state.healthPlanServices.attachmentOptions,
        error: state.healthPlanServices.error,
        hpIdentity: state.session.healthPlanUserProfile,
        swhp: state.domain.hi,
        isFetching: state.healthPlanServices.isFetching,
        crmCreateTicketResponse: state.healthPlanServices.crmSendMessageResponse,
        supportNoteMessage: state.healthPlanServices.supportNoteMessage,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        createCrmTicket: (msgType, msgDesc, fileName, attachment, title, mimetype, hpSourceSystem) => dispatch({ type: types.HP_CREATE_CRM_TICKET_START, msgType: msgType, msgDesc: msgDesc, fileName: fileName, attachment: attachment, title: title, mimetype: mimetype, hpSourceSystem: hpSourceSystem }),
        getSupportNotice: () => dispatch({ type: types.HP_GET_SUPPORT_NOTIFICATION_START})
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SupportNewRequest));
